<template>
  <div class="browser-container">
    <div class="wrapper">
      <h1 class="title">Choose Сryptocurrency</h1>
      <div>
      <ul class="item-list">
        <router-link to="/step3">
          <li class="item active">
          <div class="icon-wrapper">
            <svgicon name="bitcoin" width="49" height="49" :original="true"></svgicon>
          </div>
          <span class="item-caption active">Bitcoin</span>
        </li>
        </router-link>
        <li class="item">
          <div class="icon-wrapper">
            <svgicon name="litecoin" width="49" height="49" :original="true"></svgicon>
          </div>
          <span class="item-caption">Litecoin</span>
        </li>
      </ul>
      </div>
    </div>
  </div>
</template>

<script>
import '../../assets/compiled-icons';

export default {
  name: 'Step2'
};
</script>

<style scoped>
.item-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 408px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/steps/Step2.vue